export enum AuthActionTypes {
    LOADING = "[App Action][Auth] LOADING",
    NOT_LOADING = "[App Action][Auth] NOT LOADING",

    LOGIN = "[App Action][Auth] LOGIN",
    LOGIN_SUCCESS = "[App Action][Auth] LOGIN SUCCESS",
    LOGIN_FAIL = "[App Action][Auth] LOGIN FAIL",

    SIGNUP = "[App Action][Auth] SIGNUP",
    SIGNUP_SUCCESS = "[App Action][Auth] SIGNUP SUCCESS",
    SIGNUP_FAIL = "[App Action][Auth] SIGNUP FAIL",

    RECOVER = "[App Action][Auth] RECOVER",
    RECOVER_SUCCESS = "[App Action][Auth] RECOVER SUCCESS",
    RECOVER_FAIL = "[App Action][Auth] RECOVER FAIL",

    NEW_PASSWORD = "[App Action][Auth] NEW PASSWORD",
    NEW_PASSWORD_SUCCESS = "[App Action][Auth] NEW PASSWORD SUCCESS",
    NEW_PASSWORD_FAIL = "[App Action][Auth] NEW PASSWORD FAIL",

    SHOULD_REDIRECT = "[App Action][Auth] SHOULD REDIRECT",
    RESET_REDIRECT = "[App Action][Auth] RESET REDIRECT",

    CHANGE_USER_STATUS = "[App Action][Auth] CHANGE USER STATUS",
    CHANGE_USER_STATUS_FAIL = "[App Action][Auth] CHANGE USER STATUS FAIL",

    GET_USERS_LIST = "[App Action][Auth] GET USERS LIST",
    GET_USERS_LIST_SUCCESS = "[App Action][Auth] GET USERS LIST SUCCESS",
    GET_USERS_LIST_FAIL = "[App Action][Auth] GET USERS LIST FAIL",

    GET_USERS_PRIVILEGES = "[App Action][Auth] GET USERS PRIVILEGES",
    GET_USERS_PRIVILEGES_SUCCESS = "[App Action][Auth] GET USERS PRIVILEGES SUCCESS",
    GET_USERS_PRIVILEGES_FAIL = "[App Action][Auth] GET USERS PRIVILEGES FAIL",

    EDIT_USER = "[App Action][Auth] EDIT USER",
    EDIT_USER_FAIL = "[App Action][Auth] EDIT USER FAIL",

    EDIT_USER_PASSWORD = "[App Action][Auth] EDIT USER PASSWORD",
    EDIT_USER_PASSWORD_SUCCESS = "[App Action][Auth] EDIT USER PASSWORD SUCCESS",
    EDIT_USER_PASSWORD_FAIL = "[App Action][Auth] EDIT USER PASSWORD FAIL",

    CREATE_USER = "[App Action][Auth] CREATE USER",
    CREATE_USER_FAIL = "[App Action][Auth] CREATE USER FAIL",

    GET_ROLES_LIST = "[App Action][Auth] GET ROLES LIST",
    GET_ROLES_LIST_SUCCESS = "[App Action][Auth] GET ROLES LIST SUCCESS",
    GET_ROLES_LIST_FAIL = "[App Action][Auth] GET ROLES LIST FAIL",

    GET_RESOURCE_ENTITY= "[App Action][Auth] GET RESOURCE ENTITY",
    GET_RESOURCE_ENTITY_SUCCESS = "[App Action][Auth] GET RESOURCE ENTITY SUCCESS",
    GET_RESOURCE_ENTITY_FAIL = "[App Action][Auth] GET RESOURCE ENTITY FAIL",

    CREATE_ROLE = "[App Action][Auth] CREATE ROLE",
    CREATE_ROLE_FAIL = "[App Action][Auth] CREATE ROLE FAIL",
    CREATE_ROLE_SUCCESS = "[App Action][Auth] CREATE ROLE SUCCESS",
    OPEN_DRAWER = "[App Action][Auth] OPEN ROLE DRAWER",

    DELETE_ROLE = "[App Action][Auth] DELETE ROLE",
    DELETE_ROLE_FAIL = "[App Action][Auth] DELETE ROLE FAIL",

    EDIT_ROLE = "[App Action][Auth] EDIT ROLE",
    EDIT_ROLE_FAIL = "[App Action][Auth] EDIT ROLE FAIL",
    EDIT_ROLE_SUCCESS = "[App Action][Auth] EDIT ROLE SUCCESS",

    ADD_USER_TO_ROLE = "[App Action][Auth] ADD USER TO ROLE",
    ADD_USER_TO_ROLE_FAIL = "[App Action][Auth] ADD USER TO ROLE FAIL",

    DELETE_USER_IN_ROLE = "[App Action][Auth] DELETE USER IN ROLE",
    DELETE_USER_IN_ROLE_FAIL = "[App Action][Auth] DELETE USER IN ROLE FAIL",

    GET_SUBSIDIARIES = "[App Action][Auth] GET SUBSIDIARIES",
    GET_SUBSIDIARIES_SUCCESS = "[App Action][Auth] GET SUBSIDIARIES SUCCESS",
    GET_SUBSIDIARIES_FAIL = "[App Action][Auth] GET SUBSIDIARIES FAIL"
}
